module.exports = __webpack_public_path__ + "static/media/300_4.a0261f72.jpg";